const PROJECTS_SORT_OPTIONS = [
  {
    label: 'Recently updated',
    value: '-updated_at',
  },
  {
    label: 'Least recently updated',
    value: 'updated_at',
  },
  {
    label: 'Recently created',
    value: '-created_at',
  },
  {
    label: 'Least recently created',
    value: 'created_at',
  },
  {
    label: 'A-Z',
    value: 'name',
  },
  {
    label: 'Z-A',
    value: '-name',
  },
];

export default PROJECTS_SORT_OPTIONS;
